module.exports = __webpack_public_path__ + "static/img/3-3.602082a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-3.jpg
// module id = 738
// module chunks = 1